import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './OrderButtons.css';
import Button from '../../../components/UI/Button/Button';


class OrderButtons extends Component {
    render () {        
        return (
            <div className={classes.OrderButtons}>
                
                <Button 
                    btnType="Success"
                    clicked={this.props.onOrderSubmitted}>SUBMIT ORDER</Button>

                <Button 
                    btnType="Danger"
                    clicked={this.props.onOrderCancelled}>CANCEL</Button>
            </div>
        );
    }
};


const mapStateToProps = state => {
    return {
        isAuthenticated: state.orders.token !== null
    };
}


export default connect(mapStateToProps)( OrderButtons);


// WEBPACK FOOTER //
// ./src/components/Order/OrderButtons/OrderButtons.js